import type { HTMLComponent } from "@commercekit/react";
import WvLink from "../atoms/WvLink";
import { useLocale, useLocalePath } from "@commercekit/remix/index";
import type { BlogPostContentPageDocument } from "~/lib/prismic";
import { asDate, asText } from "@prismicio/helpers";
import { PrismicImage } from "@prismicio/react";

// Same compression as prod (Prismic default); fit=max never upscales originals smaller than the requested width
const imgixParams = {
  auto: ["format" as const, "compress" as const],
  fit: "max" as const,
};

const WvBlogPageNewsItem: HTMLComponent<{
  blogPost: BlogPostContentPageDocument;
}> = ({ blogPost }) => {
  const localePath = useLocalePath();
  const { locale } = useLocale();

  return (
    <article className="newsitem ">
      <WvLink to={localePath(`/${blogPost.uid}/`)} className="double">
        <span className="image img img__absolute">
          <PrismicImage
            field={blogPost.data.image}
            imgixParams={imgixParams}
            widths={[480, 828, 1200, 1600]}
            // Cards are ~450px wide on desktop but cover a ~450px tall box, so a landscape image needs ~680px of width
            sizes="(min-width: 1200px) 680px, 100vw"
            fallbackAlt=""
            loading="lazy"
          />
        </span>
        <span className="date">
          <strong>
            {asDate(blogPost.data.date_posted)?.toLocaleDateString(locale, {
              day: "2-digit",
            })}
          </strong>{" "}
          {asDate(blogPost.data.date_posted)?.toLocaleDateString(locale, {
            month: "short",
          })}
        </span>
        <span className="overlay">
          <h4>{asText(blogPost.data.title)}</h4>
          {asText(blogPost.data.short_introduction)}....
        </span>
        <button
          type="button"
          className="btn btn-warning"
          data-icon-after=""
        ></button>
      </WvLink>
    </article>
  );
};
export default WvBlogPageNewsItem;
